type BuildInfo = {
  buildNo: string
  buildTime?: string
}

export const buildInfo: BuildInfo = {
  buildNo: '7_4',
  buildTime: '2026-10-09T07:10:48.013Z',
}
